import { createApiWikifolioPriceUrl } from "src/constants/urls";
import { useQuery } from "src/lib/tanstack-query/hooks/use-query";
import { IPriceResponse } from "./wikifolio-price.api.types";

export function useWikifolioPriceQuery(wikifolioId: string, nonPrimaryIsin?: string, retry = 0) {
    const queryParams = new URLSearchParams();
    if (nonPrimaryIsin) {
        queryParams.set("nonPrimaryIsin", nonPrimaryIsin);
    }
    return useQuery<IPriceResponse>({
        url: createApiWikifolioPriceUrl(wikifolioId),
        queryParams,
        retry: retry,
    });
}
